export default __webpack_public_path__ + "static/media/BASAVARAJ.6a5c7ee7.JPG";